import { LuSquarePen, LuTriangleAlert } from "react-icons/lu";
import { colors, typography, effects } from "../../../design/tokens";

export default function ProjectSettingsPackageNameConfirmation({
  onCancel,
  onSave,
}: {
  onCancel: () => void;
  onSave: () => void;
}) {
  return (
    <div
      className="w-full h-full p-8
    flex flex-col items-center gap-5"
    >
      <div
        className="flex flex-col items-center gap-2
      text-yellow-500"
      >
        <LuTriangleAlert size={80} />
        <p className={`${typography.size["3xl"]} ${typography.weight.semibold}`}>Warning</p>
      </div>
      <p className={`text-center ${colors.text.secondary} ${typography.size.base}`}>
        If your mobile application has been already published, changing its{" "}
        <strong className={typography.weight.semibold}>package name</strong> will prevent you from updating your
        application.
      </p>
      <div className="flex items-center justify-center gap-5 pt-5">
        <button
          className={`${typography.size.base} ${colors.text.primary}
          px-4
        ${colors.hover.brightness} ${effects.transition.default}`}
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          id="project-settings-package-name-confirmation-save"
          className={`flex items-center justify-center gap-2
        bg-primary-blue px-4 py-2 ${effects.borderRadius.full}
        text-white ${typography.size.sm} ${typography.weight.semibold}
        ${colors.hover.opacity} ${effects.transition.default}
        disabled:opacity-50
        disabled:cursor-not-allowed
        disabled:hover:opacity-50`}
          onClick={onSave}
        >
          <LuSquarePen size={16} />
          Save
        </button>
      </div>
    </div>
  );
}
